// extracted by mini-css-extract-plugin
module.exports = {"icon":"DrawerItems_icon__mvcCI"};